import { createAction } from '@mews/framework';
import { CommanderThunkAction, WithAvailabilityBlockId, WithGroupId } from '@mews-commander/types';
import { ResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { DESTROY_AVAILABILITY_BLOCK_SCOPE } from '../actionTypes';
import { openModal } from '../../app/actions/common';
import { getAvailabilityBlockActionLogUrl } from '../utils';
import { getAvailabilityBlockRateDetailUrl } from '../selectors';

export const destroyAvailabilityBlockScope = () => createAction(DESTROY_AVAILABILITY_BLOCK_SCOPE);

export const showAvailabilityBlockActionLog =
    ({ availabilityBlockId }: WithAvailabilityBlockId): CommanderThunkAction =>
    (dispatch, _, { resolveRoute }) => {
        const url = getAvailabilityBlockActionLogUrl(resolveRoute)({ availabilityBlockId });
        return dispatch(openModal(url));
    };

export const showAvailabilityBlockRateDetail =
    ({ availabilityBlockId }: WithAvailabilityBlockId): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const state = getState();
        const url = getAvailabilityBlockRateDetailUrl(state, { id: availabilityBlockId, resolveRoute });
        return dispatch(openModal(url));
    };

const getReservationGroupDetailUrl = (resolveRoute: ResolveRoute) => (groupId: string) =>
    resolveRoute(RouteName.ReservationGroupDetail, { id: groupId });

export const showReservationGroupDetail =
    ({ groupId }: WithGroupId): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = getReservationGroupDetailUrl(resolveRoute)(groupId);
        dispatch(openModal(url));
    };
